import { mergeTravellersByMaxPerType } from 'lib/insurance/insuranceOccupants'
import { countTravellers } from 'checkout/lib/utils/travellerSchema/countTravellers'

export function finaliseInsuranceItems(
  insuranceItems: Array<App.Checkout.InsuranceTravellerFormSchema>,
  flightItems: Array<App.Checkout.FlightSchemaRequestItem>,
) {
  const thereAreInsuranceAndFlightItems = flightItems.length && insuranceItems.length

  if (!thereAreInsuranceAndFlightItems) {
    return insuranceItems
  }

  // Get merged flight travellers using max-per-type (consistent with quote fetching)
  const flightsTravellers = getFlightsTravellers(flightItems)

  // Compare insurance travellers against merged flight travellers
  const insuranceCounts = countTravellers(insuranceItems[0].travellers)
  const flightCounts = countTravellers(flightsTravellers)

  const typesMatch =
    insuranceCounts.adults === flightCounts.adults &&
    insuranceCounts.children === flightCounts.children &&
    insuranceCounts.infants === flightCounts.infants

  // If counts match exactly, use flight travellers directly
  if (insuranceItems[0].travellers.length === flightsTravellers.length && typesMatch) {
    return insuranceItems.map(item => ({ ...item, travellers: flightsTravellers }))
  }

  // Otherwise, merge using max-per-type algorithm
  return insuranceItems.map(item => {
    const { travellers: insuranceTravellers } = item
    const mergedTravellers = mergeTravellersByMaxPerType(insuranceTravellers, flightsTravellers)
    return {
      ...item,
      travellers: mergedTravellers,
    }
  })
}

function getFlightsTravellers(flightItems: Array<App.Checkout.FlightSchemaRequestItem>) {
  return flightItems.map(item => item.occupants).reduce((acc, curr) => {
    const { adults: accAdults, children: accChildren, infants: accInfants } = countTravellers(acc)
    const { adults: currAdults, children: currChildren, infants: currInfants } = countTravellers(curr)

    const adults = accAdults > currAdults ? accAdults : currAdults
    const children = accChildren > currChildren ? accChildren : currChildren
    const infants = accInfants > currInfants ? accInfants : currInfants

    return [
      ...new Array(adults).fill({ type: 'adult' }),
      ...new Array(children).fill({ type: 'child' }),
      ...new Array(infants).fill({ type: 'infant' }),
    ]
  }, flightItems[0].occupants)
}
